"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRefetch = require("react-refetch");

var _urijs = _interopRequireDefault(require("urijs"));

var _Container = _interopRequireDefault(require("./Container"));

var _CalloutAlert = _interopRequireDefault(require("./CalloutAlert"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Loading = function Loading(_ref) {
  var spinnerUrl = _ref.spinnerUrl;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "Loading...",
    src: spinnerUrl
  }));
};

var failAndShowMessage = function failAndShowMessage(_ref2) {
  var onFailure = _ref2.onFailure,
      request = _ref2.request,
      message = _ref2.message;
  Boolean(onFailure) && onFailure({
    url: request.url,
    method: request.method,
    message: message
  });
  return /*#__PURE__*/_react["default"].createElement(_CalloutAlert["default"], {
    error: {
      description: "There was a problem contacting the Expression Atlas server. Please try again in a few seconds. ",
      name: "Error",
      message: message
    }
  });
};

var showMessage = function showMessage(message) {
  return failAndShowMessage({
    onFailure: function onFailure() {},
    request: {},
    message: message
  });
};

var ContainerLoader = function ContainerLoader(props) {
  var inProxy = props.inProxy,
      atlasUrl = props.atlasUrl,
      fail = props.fail,
      sourceUrlFetch = props.sourceUrlFetch;

  if (sourceUrlFetch.pending) {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      spinnerUrl: inProxy + (0, _urijs["default"])("resources/images/loading.gif", atlasUrl).toString()
    });
  } else if (sourceUrlFetch.value === null) {
    // sourceUrlFetch.value===null covers the case in which the promise is rejected and also when the JSON payload is
    // empty; the latter can happen when the web app fails to respond within the EBI time window of 30 seconds
    return failAndShowMessage({
      onFailure: fail,
      request: sourceUrlFetch.meta.request,
      // It’s interesting to note that on an empty response Firefox reports the promise as rejected but Chrome does not
      message: sourceUrlFetch.rejected ? sourceUrlFetch.reason.message : "request to ".concat(sourceUrlFetch.meta.request.url, " failed")
    });
  } else if (sourceUrlFetch.fulfilled) {
    if (sourceUrlFetch.value.error) {
      return failAndShowMessage({
        onFailure: fail,
        request: sourceUrlFetch.meta.request,
        message: sourceUrlFetch.value.error
      });
    } else if (!sourceUrlFetch.value.profiles) {
      return showMessage("Sorry, no results could be found matching your query.");
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Container["default"], _extends({}, props, {
        data: sourceUrlFetch.value
      }));
    }
  }
};

ContainerLoader.propTypes = {
  inProxy: _propTypes["default"].string.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  source: _propTypes["default"].shape({
    endpoint: _propTypes["default"].string.isRequired,
    params: _propTypes["default"].object.isRequired
  }).isRequired,
  fail: _propTypes["default"].func
};

var _default = (0, _reactRefetch.connect)(function (props) {
  return {
    sourceUrlFetch: {
      headers: {
        //the Atlas webapp is based on Spring; given this header it'll understand the body content to be equivalent to query parameters
        'Content-Type': "application/x-www-form-urlencoded"
      },
      url: props.inProxy + (0, _urijs["default"])(props.source.endpoint, props.atlasUrl),
      method: "POST",
      //the webapp also supports GET - we do POST in case the parameters get very large
      body: Object.entries(props.source.params).map(function (p) {
        return "".concat(p[0], "=").concat(typeof p[1] === "string" ? p[1] : JSON.stringify(p[1]));
      }).join("&")
    }
  };
})(ContainerLoader);

exports["default"] = _default;